<template>
  <div>
    <div v-if="hasItems" class="mt-2">
      <h3 class="body-2 font-weight-bold mb-2">
        Existing MOU
      </h3>
      <v-data-table
        class="nav-table mb-4"
        :headers="headers"
        :items="items"
        disable-sort
        hide-default-footer
      >
        <template #item.action="{item}">
          <!--          <v-tooltip top>-->
          <!--            <template #activator="{on}">-->
          <!--              <v-btn-->
          <!--                icon-->
          <!--                :href="item.url"-->
          <!--                target="_blank"-->
          <!--                class="mr-2 btn-medium"-->
          <!--                v-on="on"-->
          <!--              >-->
          <!--                <v-icon>mdi-eye</v-icon>-->
          <!--              </v-btn>-->
          <!--            </template>-->
          <!--            <span>View</span>-->
          <!--          </v-tooltip>-->

          <v-tooltip top>
            <template #activator="{on}">
              <v-btn
                icon
                color="primary"
                class="btn-medium mr-2"
                v-on="on"
                @click="downloadFile(item)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Download</span>
          </v-tooltip>

          <v-tooltip top>
            <template #activator="{on}">
              <v-btn
                icon
                color="error"
                class="btn-medium"
                v-on="on"
                @click="removeItem(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-divider />
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';

export default {
  name: 'mou-table',
  props: {
    formRequest: {}
  },
  data: () => ({
    headers: [
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Action',
        value: 'action',
        align: 'center',
        sortable: false
      }
    ],
    items: []
  }),
  computed: {
    hasItems() {
      return this.items.length > 0;
    }
  },
  watch: {
    formRequest: {
      immediate: true,
      handler(form) {
        this.items = form?.document?.final_mou || [];
      }
    },
    items: {
      deep: true,
      immediate: true,
      handler(items) {
        this.$emit('input', items);
      }
    }
  },
  methods: {
    async removeItem(item) {
      const result = await Swal.fire({
        title: '',
        text: `Are you sure want to remove this item?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      });

      if (result) {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
        this.$emit('removed', this.items);
      }
    },
    downloadFile(item) {
      saveAs(item.url);
    }
  }
};
</script>
